/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Label_Setup_CodeInputs */

const en_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup code`)
};

const es_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de configuración`)
};

const de_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtungscode`)
};

const zh_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置码`)
};

const ar_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز الإعداد`)
};

const fr_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de configuration`)
};

const vi_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã thiết lập`)
};

const sw_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimbo wa kuweka akaunti`)
};

const th_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รหัสตั้งค่า`)
};

const bs_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod za postavljanje`)
};

const ja_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定コード`)
};

const ko_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정 코드`)
};

const pt_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de configuração`)
};

const it_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di configurazione`)
};

const sv_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringskod`)
};

const nl_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activatiecode`)
};

const da_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringskode`)
};

const nb_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringskode`)
};

const fi_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivointikoodi`)
};

const pl_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod aktywacyjny`)
};

const ru_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код активации`)
};

const tr_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinleştirme kodu`)
};

const hi_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटअप कोड`)
};

const id_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode aktivasi`)
};

const ms_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod pengaktifan`)
};

const cs_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivační kód`)
};

const el_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κωδικός ενεργοποίησης`)
};

const he_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קוד הגדרה`)
};

const af_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opstelkode`)
};

const hu_auth_label_setup_code = /** @type {(inputs: Auth_Label_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiváló kód`)
};

/**
* | output |
* | --- |
* | "Setup code" |
*
* @param {Auth_Label_Setup_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_label_setup_code = /** @type {((inputs?: Auth_Label_Setup_CodeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Label_Setup_CodeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_label_setup_code(inputs)
	if (locale === "de") return de_auth_label_setup_code(inputs)
	if (locale === "zh") return zh_auth_label_setup_code(inputs)
	if (locale === "ar") return ar_auth_label_setup_code(inputs)
	if (locale === "fr") return fr_auth_label_setup_code(inputs)
	if (locale === "vi") return vi_auth_label_setup_code(inputs)
	if (locale === "sw") return sw_auth_label_setup_code(inputs)
	if (locale === "th") return th_auth_label_setup_code(inputs)
	if (locale === "bs") return bs_auth_label_setup_code(inputs)
	if (locale === "ja") return ja_auth_label_setup_code(inputs)
	if (locale === "ko") return ko_auth_label_setup_code(inputs)
	if (locale === "pt") return pt_auth_label_setup_code(inputs)
	if (locale === "it") return it_auth_label_setup_code(inputs)
	if (locale === "sv") return sv_auth_label_setup_code(inputs)
	if (locale === "nl") return nl_auth_label_setup_code(inputs)
	if (locale === "da") return da_auth_label_setup_code(inputs)
	if (locale === "nb") return nb_auth_label_setup_code(inputs)
	if (locale === "fi") return fi_auth_label_setup_code(inputs)
	if (locale === "pl") return pl_auth_label_setup_code(inputs)
	if (locale === "ru") return ru_auth_label_setup_code(inputs)
	if (locale === "tr") return tr_auth_label_setup_code(inputs)
	if (locale === "hi") return hi_auth_label_setup_code(inputs)
	if (locale === "id") return id_auth_label_setup_code(inputs)
	if (locale === "ms") return ms_auth_label_setup_code(inputs)
	if (locale === "cs") return cs_auth_label_setup_code(inputs)
	if (locale === "el") return el_auth_label_setup_code(inputs)
	if (locale === "he") return he_auth_label_setup_code(inputs)
	if (locale === "af") return af_auth_label_setup_code(inputs)
	if (locale === "hu") return hu_auth_label_setup_code(inputs)
	return en_auth_label_setup_code(inputs)
});